export default {
    // 判断是否全是空格 | \n
    isAllSpace: str => str.match(/^\s*$/),
    // 🔗 链接
    checkUrl: url => /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(url),
    // 🆔 身份证
    checkIdCard: id => /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(id),
    // 📱 手机号
    checkPhone: phone => /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,1,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/.test(phone),
    // 📞 固定电话
    checkTel: tel => /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/.test(tel),
    // 📧 邮箱
    checkEmail: email => /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(email),
}